"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasChartFactory = void 0;
const graph_attach_point_1 = require("../templating/graph-attach-point");
const graph_attach_point_provider_1 = require("../templating/graph-attach-point-provider");
const canvas_renderer_1 = require("../rendering/canvas/canvas-renderer");
const event_service_1 = require("../eventing/event-service");
const chart_component_1 = require("./chart-component");
const canvas_context_adapter_1 = require("../rendering/canvas/canvas-context-adapter");
/**
 * @public
 * Creates canvas charts.
 */
class CanvasChartFactory {
    static createOne(options) {
        const eventService = new event_service_1.EventService();
        const attachPoint = new graph_attach_point_1.GraphAttachPoint(new graph_attach_point_provider_1.GraphAttachPointProvider(options.chartContainer), eventService, options.chartConfig);
        const contextAdapter = new canvas_context_adapter_1.CanvasContextAdapter(attachPoint.canvasElement);
        const renderer = canvas_renderer_1.CanvasRenderer.createOne(contextAdapter.getContext());
        if (renderer == null) {
            return null;
        }
        return new chart_component_1.ChartComponent(attachPoint, renderer, eventService, options.chartConfig, contextAdapter);
    }
}
exports.CanvasChartFactory = CanvasChartFactory;
//# sourceMappingURL=canvas-chart-factory.js.map